import React, { useState, useEffect } from 'react';
import { FormControl, Container } from '@mui/material';
import Radio from '@mui/material/Radio';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { environment } from 'apps/table-tuck-web/src/environments/environment';
import { firestore } from '@tabletuck/firebase-services';
import { useSelector } from 'react-redux';
import visa from '../../../assets/visa.png';
import Google from '../../../assets/google_icon.png';
import Apple from '../../../assets/Apple_logo_PNG1.png';
import CreditCard from '../../../assets/credit-card.png';
import { CustomButton } from '@tabletuck/components';
import { browserName } from './browserName';
import { red } from '@mui/material/colors';
import { auth } from '../../../../../../libs/firebase-service/src';
import amex from '../../../assets/amex.png';
import discover from '../../../assets/dicover.png';
import dinars from '../../../assets/dinars.png';
import geniric from '../../../assets/geniric.png';
import jbc from '../../../assets/geniric.png';
import mastercard from '../../../assets/mastercard.png';
import unionpay from '../../../assets/unionpay.png';
import cashimage from '../../../assets/cash.png';
import { useTranslation } from 'react-i18next';
import SquarePaymentForm from '../../components/SquarePaymentForm/SquarePaymentForm';

var isSafari = browserName == 'Apple Safari';
var isChrome = browserName == 'Google Chrome';

function PaymentsDialog({
  orderType,
  cards,
  setCards,
  handleChange,
  onSelect,
  setCredit,
  cash,
  setCash,
  sourceId,
  setSourceId,
  squarePaymentRef,
  savedCards,
  selectedSavedCardId,
  onSavedCardSelect,
  shouldSaveCard,
  onSaveCardChange,
  useNewCard,
  onUseNewCardChange,
  storeIdD,
}) {
  // const [cards, setCards] = useState([]);
  const [selectedCardIndex, setSelectedCardIndex] = useState(0);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
  const [cashSelected, setCashSelected] = useState(false);
  const [t, i18n] = useTranslation();

  const token = useSelector((state) => state.authReducer.token);
  const userData = useSelector((state) => state.authReducer.userData);
  const effectiveLocationId = storeIdD || userData?.defaultStore;

  // Component lifecycle logging
  useEffect(() => {
    console.log('🟢 [PaymentsDialog] Component MOUNTED');
    return () => {
      console.log('🔴 [PaymentsDialog] Component UNMOUNTED');
    };
  }, []);

  let getData = async () => {
    try {
      firestore
        .collection(
          `users/${auth?.currentUser?.uid}/private_data/cards/sources`
        )
        .get()
        .then((docs) => {
          let arr = [];
          docs.forEach((doc) => {
            arr.push(doc.data());
          });
          setCards(arr);
        });
    } catch (e) {
      console.log('error in payment', e.message);
    }
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        // User is signed in, fetch data
        getData();
      }
    });
    setSelectedPaymentMethod('');
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const hasCards = cards.length > 0;
    const hasCashOnDelivery = checkLicenses('cod');
    if (hasCards) {
      setSelectedPaymentMethod('0');
    } else if (hasCashOnDelivery) {
      setSelectedPaymentMethod('cash');
      setCashSelected(true);
      setCash(true);
    } else {
      setSelectedPaymentMethod('0');
    }
  }, [cards]);

  const handleClose = () => {
    setSelectedCardIndex(0);
    setCredit(false);
  };

  useEffect(() => {
    const selectedCard = cards[selectedCardIndex];
    if (selectedCard) {
      if (selectedCardIndex === cards.length) {
        onSelect('newCard');
        setCredit(true);
      } else {
        onSelect(selectedCardIndex.toString(), selectedCard);
        setCredit(false);
      }
    }
  }, [selectedCardIndex, onSelect, setCredit]);

  const handlePaymentChange = (event) => {
    const value = event.target.value;

    if (value === 'cash') {
      setSelectedPaymentMethod('cash');
      setCashSelected(true);
      setCash(true);
      setCredit(false);
      onSelect('cash');
    } else {
      setSelectedPaymentMethod(value);
      setCashSelected(false);
      setCash(false);
      setSelectedCardIndex(parseInt(value));
      setCredit(false);
    }
  };

  const licenses = useSelector((state) => state.licenReducer.licenses);

  const checkLicenses = (pageName) => {
    return licenses?.licenses.frontend?.[pageName];
  };
  if (
    environment.restaurantId === 'fattyPattyDev' ||
    environment.restaurantId === 'fattyPatty'
  ) {
    console.log(
      '💳 [PaymentsDialog] Rendering SquarePaymentForm for Fatty Patty',
      {
        savedCardsCount: savedCards?.length || 0,
        selectedSavedCardId,
        useNewCard,
        shouldSaveCard,
      }
    );

    return (
      <SquarePaymentForm
        ref={squarePaymentRef}
        locationId={effectiveLocationId}
        orderType={orderType}
        onSelect={onSelect}
        amount="1.00"
        setSourceId={setSourceId}
        sourceId={sourceId}
        savedCards={savedCards}
        selectedSavedCardId={selectedSavedCardId}
        onSavedCardSelect={onSavedCardSelect}
        shouldSaveCard={shouldSaveCard}
        onSaveCardChange={onSaveCardChange}
        useNewCard={useNewCard}
        onUseNewCardChange={onUseNewCardChange}
      />
    );
  }
  return (
    <Container open={true} style={{ padding: 0 }}>
      <div style={{ padding: 0 }}>
        {checkLicenses('payment') && (
          <>
            {cards.map((item, indx) => {
              const selected = selectedPaymentMethod === indx.toString();
              return (
                <div
                  key={item.id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    background: '#fff',
                    borderRadius: '16px',
                    boxShadow: '0 2px 12px 0 rgba(16, 30, 54, 0.06)',
                    padding: '18px 24px',
                    marginBottom: '16px',
                    border: selected
                      ? `2px solid ${environment.mainColor}`
                      : '2px solid transparent',
                    cursor: 'pointer',
                    transition: 'border 0.2s',
                  }}
                  onClick={() => {
                    setSelectedPaymentMethod(indx.toString());
                    setSelectedCardIndex(indx);
                    setCredit(false);
                    setCashSelected(false);
                    setCash(false);
                  }}
                >
                  <img
                    src={
                      item?.brand === 'American Express'
                        ? amex
                        : item?.brand === 'Diners Club'
                        ? dinars
                        : item?.brand === 'Discover'
                        ? discover
                        : item?.brand === 'JCB'
                        ? jbc
                        : item?.brand === 'Visa'
                        ? visa
                        : item?.brand === 'MasterCard'
                        ? mastercard
                        : item?.brand === 'UnionPay'
                        ? unionpay
                        : geniric
                    }
                    alt="card"
                    style={{
                      width: 36,
                      height: 36,
                      borderRadius: 8,
                      marginRight: 18,
                    }}
                  />
                  <span
                    style={{
                      fontFamily: 'Jost, sans-serif',
                      fontWeight: 600,
                      fontSize: 17,
                      color: '#1A2341',
                      letterSpacing: '0.01em',
                      flex: 1,
                    }}
                  >
                    ****{item.last4}
                  </span>
                  {selected ? (
                    <CheckCircleIcon
                      sx={{ color: environment.mainColor, fontSize: 28 }}
                    />
                  ) : (
                    <RadioButtonUncheckedIcon
                      sx={{ color: '#E0E0E0', fontSize: 28 }}
                    />
                  )}
                </div>
              );
            })}
            {/* Add New Payment */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                background: '#fff',
                borderRadius: '16px',
                boxShadow: '0 2px 12px 0 rgba(16, 30, 54, 0.06)',
                padding: '18px 24px',
                marginBottom: '16px',
                border:
                  selectedPaymentMethod === cards.length.toString()
                    ? `2px solid ${environment.mainColor}`
                    : '2px solid transparent',
                cursor: 'pointer',
                transition: 'border 0.2s',
              }}
              onClick={() => {
                setSelectedPaymentMethod(cards.length.toString());
                setSelectedCardIndex(cards.length);
                setCredit(true);
                setCashSelected(false);
                setCash(false);
                onSelect('newCard');
              }}
            >
              <img
                src={CreditCard}
                alt="add"
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 8,
                  marginRight: 18,
                }}
              />
              <span
                style={{
                  fontFamily: 'Jost, sans-serif',
                  fontWeight: 600,
                  fontSize: 17,
                  color: '#1A2341',
                  letterSpacing: '0.01em',
                  flex: 1,
                }}
              >
                {t('confirmPage.AddPayment')}
              </span>
              {selectedPaymentMethod === cards.length.toString() ? (
                <CheckCircleIcon
                  sx={{ color: environment.mainColor, fontSize: 28 }}
                />
              ) : (
                <RadioButtonUncheckedIcon
                  sx={{ color: '#E0E0E0', fontSize: 28 }}
                />
              )}
            </div>
          </>
        )}
        {/* Cash Option */}
        {checkLicenses('cod') && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              background: '#fff',
              borderRadius: '16px',
              boxShadow: '0 2px 12px 0 rgba(16, 30, 54, 0.06)',
              padding: '18px 24px',
              marginBottom: '16px',
              border: cashSelected
                ? `2px solid ${environment.mainColor}`
                : '2px solid transparent',
              cursor: 'pointer',
              transition: 'border 0.2s',
            }}
            onClick={() => {
              setSelectedPaymentMethod('cash');
              setCashSelected(true);
              setCash(true);
              setCredit(false);
              onSelect('cash');
            }}
          >
            <img
              src={cashimage}
              alt="cash"
              style={{
                width: 36,
                height: 36,
                borderRadius: 8,
                marginRight: 18,
              }}
            />
            <span
              style={{
                fontFamily: 'Jost, sans-serif',
                fontWeight: 600,
                fontSize: 17,
                color: '#1A2341',
                letterSpacing: '0.01em',
                flex: 1,
              }}
            >
              {orderType === 'delivery'
                ? t('confirmPage.CashOnDeilvery')
                : t('confirmPage.Cash')}
            </span>
            {cashSelected ? (
              <CheckCircleIcon
                sx={{ color: environment.mainColor, fontSize: 28 }}
              />
            ) : (
              <RadioButtonUncheckedIcon
                sx={{ color: '#E0E0E0', fontSize: 28 }}
              />
            )}
          </div>
        )}
      </div>
    </Container>
  );
}

// LableForm is now inlined in the main render for custom layout

export default PaymentsDialog;
